import axios from 'axios';

import { AggregateRequest } from 'core/util/Aggregate';
import { SearchRequest } from 'core/util/Search';

export const aggregateScores = async (
    tenantId: number | undefined,
    aggregateRequest: AggregateRequest,
): Promise<any> => {
    const args = { aggregateRequest };
    const { data } = await axios.put(`/api/tenants/${tenantId}/scores/aggregate`, { args });

    return data;
};

export const getScoreMetrics = async (tenantId: number | undefined, search: SearchRequest, args: any): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/score-metrics`, { params });

    return data;
};

export const getScoreTrend = async (tenantId: number | undefined, search: SearchRequest, args: any): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/score-metrics/trends`, { params });

    return data;
};

export const getScoreLocations = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const { data } = await axios.post(`/api/tenants/${tenantId}/score-metrics/locations`, { search, args });

    return data;
};

export const getInsights = async (tenantId: number | undefined, search: SearchRequest, args: any) => {
    const { data } = await axios.put(`/api/tenants/${tenantId}/score-insights/grouped-insight`, { search, args });

    return data || {};
};

export const getSignalImpacts = async (
    tenantId: number | undefined,
    search: AggregateRequest,
    args: any,
): Promise<any> => {
    const { data } = await axios.put(`/api/tenants/${tenantId}/score-insights/aggregate`, { search, args });

    return data;
};

export const getThermometerWeights = async (tenantId: number | undefined, search: SearchRequest): Promise<any> => {
    const { data } = await axios.put(`/api/tenants/${tenantId}/score-insights/thermometer-weights`, { search });

    return data;
};

export const getTargets = async (tenantId: number | undefined, search: SearchRequest): Promise<any> => {
    const params = { search };
    const { data } = await axios.get(`/api/tenants/${tenantId}/score-targets`, { params });

    return data;
};

export const saveTarget = async (tenantId: number | undefined, search: any): Promise<any> => {
    const { data } = await axios.post(`/api/tenants/${tenantId}/score-targets/save`, { search });

    return data;
};

export const importTargets = async (tenantId: number | undefined, file: File, args: any): Promise<any> => {
    const headers = { 'Content-Type': 'multipart/form-data' };
    const formData = new FormData();

    formData.append('file', file);
    formData.append('args', JSON.stringify(args));

    const { data } = await axios.post(`/api/tenants/${tenantId}/score-targets/import`, formData, { headers });

    return data;
};

export const exportTargets = async (tenantId: number | undefined, search: SearchRequest, args: any): Promise<any> => {
    const { data } = await axios.put(`/api/tenants/${tenantId}/score-targets/export`, { search, args });

    return data;
};

export const createTarget = async (tenantId: number | undefined, search: SearchRequest, args: any): Promise<any> => {
    const { data } = await axios.post(`/api/tenants/${tenantId}/score-targets/create`, { search, args });

    return data;
};

export const deleteTarget = async (tenantId: number | undefined, targetId: string): Promise<any> => {
    const { data } = await axios.delete(`/api/tenants/${tenantId}/score-targets/delete/${targetId}`);

    return data;
};

export const aggregateTargets = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/score-metrics/targets`, { params });

    return data;
};

// Rep Score Impact Report
export const searchLocationImpacts = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/rep-score-impact-report/search-location-impacts`, {
        params,
    });

    return data;
};

export const searchLocationImpactDetails = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(
        `/api/tenants/${tenantId}/rep-score-impact-report/search-location-impact-details`,
        {
            params,
        },
    );

    return data;
};

export const getAggregateImpact = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/rep-score-impact-report/get-aggregate-impact`, {
        params,
    });

    return data;
};

export const getCountryIndustryPairs = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/rep-score-impact-report/get-country-industry-pairs`, {
        params,
    });

    return data;
};

export const getSourceWeights = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/rep-score-impact-report/get-source-weights`, {
        params,
    });

    return data;
};

export const getDepartmentHealthSupport = async (
    tenantId: number | undefined,
    search: SearchRequest,
    args: any,
): Promise<any> => {
    const params = { search, args };
    const { data } = await axios.get(`/api/tenants/${tenantId}/rep-score-impact-report/department-health-support`, {
        params,
    });

    return data;
};
